// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"611532ef","763":"279ceacd"}[chunkId] + ".css";
};